import {
    BRAND_PLATFORM,
    BRAND_PLATFORM_WINDOWS_11,
    DESKTOP,
    MOBILE,
    MOBILE_WEB,
} from '@/utils/constants/common';

import { getDevicePlatform } from '../browser/getDevicePlatform';

export const getTrackingBrandPlatform = ({ siteName }: { siteName?: string }) => {
    let brandPlatform: string | undefined;
    let siteTypeDevice: string | undefined;

    if (typeof window === 'undefined' || !siteName) {
        return { brandPlatform, siteTypeDevice };
    }
    const { isMobile } = getDevicePlatform();

    if (isMobile) {
        siteTypeDevice = MOBILE;
        brandPlatform = `${siteName}${BRAND_PLATFORM}${MOBILE_WEB}`;
    } else {
        siteTypeDevice = DESKTOP;
        brandPlatform = `${siteName}${BRAND_PLATFORM}${DESKTOP}`;
    }

    const isEdge = navigator?.userAgent.includes('Edg/');
    const isInstalled = window.matchMedia('(display-mode: standalone)').matches;
    const isStorePWA = document.referrer === 'app-info://platform/microsoft-store';

    if (isEdge && isInstalled && !isStorePWA) {
        brandPlatform = `${siteName}${BRAND_PLATFORM_WINDOWS_11}`;
    }

    return { brandPlatform, siteTypeDevice };
};
